module.exports = __webpack_public_path__ + "static/media/miniwave-policie-salud.92703714.svg";